module.exports = __webpack_public_path__ + "img/earn_nav_night.9853c20a.png";